import { Box, Checkbox, FormControlLabel, FormGroup, TextField, Typography } from '@mui/material'
import { BenchmarkFilters } from 'store/reporting/benchmark/types'

type Props = {
  filters: BenchmarkFilters
  setFilters: React.Dispatch<React.SetStateAction<BenchmarkFilters>>
  companyNames: string[]
}

export default function BenchmarkFiltersComponent({ filters, setFilters, companyNames }: Props) {
  const updateParam = <K extends keyof BenchmarkFilters>(key: K, value: BenchmarkFilters[K]) => {
    setFilters(prev => ({ ...prev, [key]: value }))
  }

  return (
    <Box
      mt={2}
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        p: 2,
        // display: 'inline-block',
        '& .MuiFormControlLabel-label': { fontSize: 15 },
        '& .MuiCheckbox-root': { p: 0.5 },
      }}>
      <Typography sx={{ mb: 1 }}>Filters:</Typography>
      <FormGroup sx={{ ml: 2 }}>
        <FormControlLabel
          label=" Start year"
          control={
            <TextField
              value={filters.startYear}
              size="small"
              sx={{ width: 80, mr: 1, input: { p: 1, fontSize: 14 } }}
              onChange={e => updateParam('startYear', Number(e.target.value))}
            />
          }
        />
        <FormControlLabel
          control={<Checkbox checked={filters.grantedOnly} onChange={e => updateParam('grantedOnly', e.target.checked)} />}
          label="Granted only"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={filters.publicationDateOnly}
              onChange={e => updateParam('publicationDateOnly', e.target.checked)}
            />
          }
          label="Publication Date only"
        />
        <Typography mt={0.7} fontSize={15}>
          Companies selected: {companyNames.join(', ')}
        </Typography>
      </FormGroup>
    </Box>
  )
}
